import { render, staticRenderFns } from "./GlitchText.vue?vue&type=template&id=da0c8a1a&scoped=true&"
import script from "./GlitchText.vue?vue&type=script&lang=js&"
export * from "./GlitchText.vue?vue&type=script&lang=js&"
import style0 from "./GlitchText.vue?vue&type=style&index=0&id=da0c8a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0c8a1a",
  null
  
)

export default component.exports